import { GoToHomePage } from "../../util/UrlUtil";

export class Breadcrumb {

    public Name: string;
    public Callback: Function;
    public Current: boolean;

    constructor(name: string, callback: Function, current: boolean = false) {
        this.Name = name;
        this.Callback = callback;
        this.Current = current;
    }
}